import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Modal, ModalHeader, ModalTitle, ModalClose, ModalBody} from 'react-modal-bootstrap';
import * as modalActions from '../../actions/common/modalActions';


class PreviewModal extends React.Component {
    constructor(props) {
        super(props);
        this.hideModal = this.hideModal.bind(this);
    }

    hideModal() {
        this.props.actions.hidePreviewModal();
    }

    render() {
        if(!this.props.children) {
            return null;
        }

        return (
            <Modal className="full-screen-modal" isOpen={this.props.showPreviewModal} onRequestHide={this.hideModal}>
                <ModalHeader>
                    <ModalTitle>Gennemse</ModalTitle>
                    <ModalClose onClick={this.hideModal}/>
                </ModalHeader>
                <ModalBody>
                    {this.props.children}
                    <div className="row mt-2">
                        <div className="col-12">
                            <button type="button" className="btn btn-primary" aria-label="Close" onClick={this.hideModal}>Tilbage</button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    componentDidMount() {
        this.hideModal();
    }

    componentDidUpdate() {
        if(!this.props.children) {
            this.hideModal();
        }
    }

}

function mapStateToProps(state, ownProps) {
    return {
        showPreviewModal: state.showPreviewModal,
    };
}

function mapDispatchToProps(dispatch) {


    return {
        actions: bindActionCreators(Object.assign(
            {},
            modalActions
        ), dispatch)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewModal);


// WEBPACK FOOTER //
// ./web/src/components/common/PreviewModal.jsx